<template>
  <ElDatePicker
    :id="id"
    :model-value="modelValue"
    type="date"
    format="DD.MM.YYYY"
    value-format="DD.MM.YYYY"
    :clearable="false"
    @update:model-value="(value: string | null) => emits('update:modelValue', value || null)"
  />
</template>

<script setup lang="ts">
import { ElDatePicker } from 'element-plus';

interface Props {
  modelValue: string | null;
  id?: string;
}

defineProps<Props>();

const emits = defineEmits(['update:modelValue']);
</script>
